module.exports = __webpack_public_path__ + "static/img/firstNums.60605d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/phoneHomePage/firstNums.png
// module id = p0Mj
// module chunks = 0